const map = {
	"./images/404/404-gradient.png": 8304,
	"./images/about/about-2.jpg": 1820,
	"./images/about/awards-number.jpg": 2206,
	"./images/about/step-1.jpg": 6328,
	"./images/about/step-2.jpg": 4999,
	"./images/about/step-3.jpg": 6714,
	"./images/about/video-poster.jpg": 4713,
	"./images/favicon/Favicon.png": 3433,
	"./images/favicon/apple-touch-icon.png": 1169,
	"./images/favicon/favicon-96x96.png": 5504,
	"./images/favicon/favicon.ico": 8843,
	"./images/favicon/favicon.svg": 6286,
	"./images/favicon/web-app-manifest-192x192.png": 4760,
	"./images/favicon/web-app-manifest-512x512.png": 6768,
	"./images/home/end-page-about.jpg": 9485,
	"./images/home/latest-project-black-holes.jpg": 2429,
	"./images/home/latest-project-chasing-utopia.jpg": 9700,
	"./images/home/latest-project-creative-partnership.jpg": 3748,
	"./images/home/latest-project-galapagos.jpg": 2079,
	"./images/home/latest-project-life-before-birth.jpg": 4600,
	"./images/home/showreel-poster.png": 1289,
	"./images/loader/atlantic.svg": 5659,
	"./images/loader/atlanticstudios.svg": 5188,
	"./images/loader/loader-Titanic_NVIDIA.jpg": 4448,
	"./images/loader/loader-black-hole.jpg": 8568,
	"./images/loader/loader-chasing-utopia.jpg": 6884,
	"./images/loader/loader-featured.png": 8058,
	"./images/loader/loader-galapagos.jpg": 9919,
	"./images/loader/loader-gradient-red.png": 5550,
	"./images/loader/loader-gradient.png": 740,
	"./images/loader/loader-gradient2.png": 7532,
	"./images/loader/loader-gradient3.png": 9797,
	"./images/loader/loader-life-before-birth-3.jpg": 3940,
	"./images/loader/loader-life-before-birth.jpg": 8152,
	"./images/partners/partner-logo-bbc.png": 434,
	"./images/partners/partner-logo-channel-4.png": 3427,
	"./images/partners/partner-logo-google.png": 2292,
	"./images/partners/partner-logo-nasa.png": 8146,
	"./images/partners/partner-logo-nat-geo.png": 9724,
	"./images/partners/partner-logo-nhm.png": 1022,
	"./images/partners/partner-logo-nvidia.png": 288,
	"./images/partners/partner-logo-sky.png": 5462,
	"./images/partnerships/slide-1-apple.jpg": 9386,
	"./images/partnerships/slide-2-google.jpg": 752,
	"./images/partnerships/slide-3-nvidia.jpg": 3599,
	"./images/projects/project-2025-from-space.jpg": 8530,
	"./images/projects/project-belsen.jpg": 672,
	"./images/projects/project-chasing-utopia.jpg": 5177,
	"./images/projects/project-cosmos-unseen.jpg": 9836,
	"./images/projects/project-hawking.jpg": 8532,
	"./images/projects/project-inside-the-commons.jpg": 1938,
	"./images/projects/project-jerusalem.jpg": 9603,
	"./images/projects/project-life-before-birth.jpg": 8487,
	"./images/projects/project-mulitple-projects-david-a.jpg": 5371,
	"./images/projects/project-natural-history-museum.jpg": 5212,
	"./images/projects/project-rashid-rover.jpg": 8663,
	"./images/projects/project-the-coronation.jpg": 2729,
	"./images/projects/project-the-promised-land.jpg": 8238,
	"./images/projects/project-the-wildest-dream.jpg": 5265,
	"./images/projects/project-titanic.jpg": 2783,
	"./images/projects/project-ve80.jpg": 7630,
	"./images/svg/atlantic-footer.svg": 9452,
	"./images/svg/logo-footer.svg": 4239,
	"./images/wp-login.png": 5299,
	"./images/wp-login@2x.png": 9917
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4283;